import { Component, Input, OnInit } from '@angular/core';
import { MasterService } from '../../../../services/master.service'
import { MessageService } from '../../../../services/message.service'
import * as languageLibrary from '../../../../services/language'
import { SecurityService } from 'src/app/services/security.service';
import { User } from 'src/app/models/user.model';
import { Corporation } from 'src/app/models/corporation.model';
import { Subscription } from "rxjs";

@Component({
    selector: 'users-roles',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: false
})
export class UsersRolesComponent implements OnInit {
    
    // save the language
    protected language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'

    // set all words
    protected words = languageLibrary.language

    //  user list
    protected users: User[] = []

    // 
    protected corporation: Corporation;

    // define the user selected
    protected userSelected: any = {}

    // define the status loading
    protected loading: boolean = false

    // define the lot id
    protected lotId: number = 0

    // count the administrators
    private administrators: number = 0

    // A handle to navbar event messages so we can unsubscribe later.
    private navbarWatcher: Subscription | null = null

    /*
    * life cycles
    */

    constructor(private master: MasterService, private ms: MessageService, protected security: SecurityService) {}

    ngOnInit() {
        // get users
        this.getUsers(true)
        
        // get lots   
        this.getCorporations()

        // reload roles
        this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {
            switch (res.message) {
                case 'reloadRoles':
                case 'setPermissions':
                    this.getUsers(false)
                    break
                case 'changeLanguage':
                    this.language = res.value
                    break
            }
        })
    }

    ngOnDestroy() {
        if (!this.navbarWatcher) {
            return
        }

        this.navbarWatcher.unsubscribe()
    }
    
    //  get all users
    protected getUsers = (loading): void => {
        this.master.get(`users/roles`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.users = res.data.users

            if (!this.userSelected || !this.users || (this.users.length <= 0)) {
                return
            }

            for (const user of this.users) {
                if (user.id !== this.userSelected.userId) {
                    continue
                }

                this.userSelected.roles = user.roles
                this.userSelected.roleId = 0
            }
        })
    }

    // get all lots
    protected getCorporations = (): void => {
        this.master.get('corporations', res => {
            this.loading = false
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.corporation = res.data.corporate
        })
    }
    
    /*
    * delete a lot in the role
    @ lotId: define the lot id to deleted
    @ userid: define the id to user
    @ roleId: define the role id that lot will be deleted
    @ userIndex: define the index of user
    @ relationshipIndex: define the index of relationship
    @ lotIndex: define the index of lot
    */
    protected deleteLot = (lotId: number, userId: number, roleId: number, userIndex: number, relationshipIndex: number, lotIndex: number): void => {
        this.master.post('userRoleSwitch', { lotId: lotId, userId: userId, roleId: roleId, type: 'remove' }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] })
            this.reloadLots()

            // remove item from lots array
            this.users[userIndex]['relationship'][relationshipIndex].lots.splice(lotIndex, 1)
        })
    }


    protected deleteRole = (userId: number, roleId: number, role): void => {
        // check admin exist
        let administrators = 0

        for (let index = 0; index < this.users.length; index++) {
            if (this.users[index]['relationship'].some(el => el.roleName == "Administrator")) {
                administrators = administrators + 1
            }
        }
        if (administrators > 1 || role.roleName != 'Administrator') {

            // delete admin only if exist more admins
            // delete role
            this.master.post('userRoleSwitch', { userId: userId, roleId: roleId, type: 'remove' }, res => {
                if (res) {
                    if (res.status == 200) {
                        // * success
                        this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });
                        // reload user
                        this.getUsers(false)

                    } else {
                        // ! error
                        this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                    }
                } else {
                    // api no response
                    this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                }
            })
        } else {
            // if only exist one admin
            this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['noAdminError'] });
        }
    }

    /*
    * toggle checkout roles by user
    @ lotId: define the lot id to deleted
    @ userid: define the id to user
    @ roleId: define the role id that lot will be deleted
    @ userIndex: define the index of user
    @ relationshipIndex: define the index of relationship
    @ lotIndex: define the index of lot
    */
    protected toggleRole = (userId: number, roleId: number, checked: boolean, i: number, role: Object, event): void => {

        // check admin exist
        let administrators = 0

        for (let index = 0; index < this.users.length; index++) {
            if (this.users[index]['relationship'].some(el => el.roleName == "Administrator")) {
                administrators = administrators + 1
            }
        }


        if (administrators > 1 || role['name'] != 'Administrator' || (role['name'] == 'Administrator' && !this.userSelected['roles'][i].checked)) {
            // change input

            this.master.post('userRoleSwitch', { userId: userId, roleId: roleId, type: checked ? 'remove' : 'assign' }, res => {

                if (res) {
                    if (res.status == 200) {
                        // * success
                        this.userSelected['roles'][i].checked = !this.userSelected['roles'][i].checked
                        let message = ""
                        checked ? message = "removed" : message = "assigned"
                        this.ms.sendMessage("alert", { type: "success", text: `Role ${message} success!` });
                        // reload user
                        this.getUsers(false)
                    } else {
                        // ! error
                        this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                    }
                } else {
                    // api no response
                    this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
                }
            })
        } else {
            // if only exist one admin
            event.srcElement.checked = true
            this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['noAdminError'] });
        }

    }

    /*
    * add lot to role
    @ lotId: define the lot id to assigned
    @ userid: define the id to user
    @ roleId: define the role id that will be added
    */
    protected addLot = (userId: number, roleId: number): void => {
        const id = this.lotId
        if (!id || (id <= 0)) {
            return
        }

        this.master.post('userRoleSwitch', { lotId: id, userId: userId, roleId: roleId, type: 'entity' }, res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.lotId = 0
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.ms.sendMessage("alert", { type: "success", text: this.words[this.language]['success'] });

            // reload lots      
            this.lotId = 0
            this.reloadLots()

            // reload roles
            this.getUsers(false)
        })
    }

    protected reloadLots = (): void => {
        this.master.get('users/account', res => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            // send permissions for all components
            this.ms.channelComponents$.emit({ message: 'updateLotList', section: 'users', value: res['data']['user'].lots })
        })
    }
    
    // select a user
    protected selectUser = (userId: number, roleId: number, roles: string[], index: number): void => {
        this.administrators = 0

        for (let index = 0; index < this.users.length; index++) {
            if (this.users[index]['relationship'].some(el => el.roleName == "Administrator")) {
                this.administrators = this.administrators + 1
            }
        }

        this.userSelected = { userId: userId, roleId: roleId, roles: roles, index: index }
    }

}
